import template from './calendarGrid.html';
import controller from './calendarGrid.controller';
import './calendarGrid.scss';

let calendarGridComponent = {
  restrict: 'E',
  bindings: {
    loaded: '<',
    selectDay: '&',
    filters: '<',
    user: '<',
    isInception: '<',
    isTabletResolution: '<',
    format: '<',
    isMobileApp: '<',
    isMobileSchedule: '<',
    dateToday: '<',
    onClickPrevious: '&',
    onClickNext: '&',
  },
  template,
  controller,
};

export default calendarGridComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarGrid/calendarGrid.component.js